"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYNC_STRATEGIES = exports.ProjectSerializedOut = exports.ProjectSerializedIn = exports.ForeignType = exports.TaxExemptionStatus = exports.ProjectShippingType = exports.ProjectInfoSource = exports.ProjectFulfillmentMethod = exports.ProjectConfigurationSerialized = exports.ProjectConfiguration = exports.ProjectItem = exports.Product = exports.Design = exports.SizeQuantity = exports.CoreOrderData = exports.PriorityTurnTimes = exports.TurnTime = exports.DistributedOrderData = exports.Project = exports.ProjectKey = void 0;
// DynamoDB hash key
class ProjectKey {
    constructor() {
        this.id = '';
        this.version = 0;
    }
}
exports.ProjectKey = ProjectKey;
// All other DynamoDB fields
class Project extends ProjectKey {
}
exports.Project = Project;
class DistributedOrderData {
}
exports.DistributedOrderData = DistributedOrderData;
var TurnTime;
(function (TurnTime) {
    TurnTime["STANDARD"] = "STANDARD";
    TurnTime["QUICKER"] = "QUICKER";
    TurnTime["RUSH"] = "RUSH";
    TurnTime["SUPERRUSH"] = "SUPERRUSH";
})(TurnTime = exports.TurnTime || (exports.TurnTime = {}));
class PriorityTurnTimes {
}
exports.PriorityTurnTimes = PriorityTurnTimes;
class CoreOrderData {
}
exports.CoreOrderData = CoreOrderData;
class SizeQuantity {
}
exports.SizeQuantity = SizeQuantity;
class Design {
}
exports.Design = Design;
class Product {
}
exports.Product = Product;
class ProjectItem {
}
exports.ProjectItem = ProjectItem;
class ProjectConfiguration {
}
exports.ProjectConfiguration = ProjectConfiguration;
class ProjectConfigurationSerialized {
}
exports.ProjectConfigurationSerialized = ProjectConfigurationSerialized;
var ProjectFulfillmentMethod;
(function (ProjectFulfillmentMethod) {
    ProjectFulfillmentMethod["BULK"] = "BULK";
    ProjectFulfillmentMethod["BSS"] = "BSS";
    ProjectFulfillmentMethod["FUNDRAISER"] = "FUNDRAISER";
    ProjectFulfillmentMethod["GROUPS"] = "GROUPS";
    ProjectFulfillmentMethod["STORES"] = "STORES";
})(ProjectFulfillmentMethod = exports.ProjectFulfillmentMethod || (exports.ProjectFulfillmentMethod = {}));
var ProjectInfoSource;
(function (ProjectInfoSource) {
    ProjectInfoSource["COMMUNITY"] = "COMMUNITY";
    ProjectInfoSource["ORGANIZER"] = "ORGANIZER";
})(ProjectInfoSource = exports.ProjectInfoSource || (exports.ProjectInfoSource = {}));
var ProjectShippingType;
(function (ProjectShippingType) {
    ProjectShippingType["BULK"] = "BULK";
    ProjectShippingType["INDIVIDUAL"] = "INDIVIDUAL";
    ProjectShippingType["INVENTORY"] = "INVENTORY";
})(ProjectShippingType = exports.ProjectShippingType || (exports.ProjectShippingType = {}));
var TaxExemptionStatus;
(function (TaxExemptionStatus) {
    TaxExemptionStatus["NON_EXEMPT"] = "NON_EXEMPT";
    TaxExemptionStatus["CLAIMED"] = "CLAIMED";
    TaxExemptionStatus["EXEMPT"] = "EXEMPT";
})(TaxExemptionStatus = exports.TaxExemptionStatus || (exports.TaxExemptionStatus = {}));
var ForeignType;
(function (ForeignType) {
    ForeignType["CORE_ORDER"] = "CORE_ORDER";
})(ForeignType = exports.ForeignType || (exports.ForeignType = {}));
class ProjectSerializedIn {
}
exports.ProjectSerializedIn = ProjectSerializedIn;
class ProjectSerializedOut extends ProjectSerializedIn {
}
exports.ProjectSerializedOut = ProjectSerializedOut;
exports.SYNC_STRATEGIES = {
    DESIGN: 'DESIGN',
    CORE_ORDER: 'CORE_ORDER',
};
